import type { IInboxEntry } from './IInboxEntry';
import type { InboxShow } from './InboxShow';

/** Пункти «Показати» в порядку меню (прототип v4: Усі · Непрочитані · Доручення · Нагадування · Коментарі · Оновлення). */
export const INBOX_SHOW: readonly InboxShow[] = ['all', 'unread', 'assignment', 'reminder', 'comment', 'update'];

/** Чи рядок — ключ фільтра «Показати» (параметр ?show=). */
export const isInboxShow = (value: string | null): value is InboxShow => INBOX_SHOW.includes(value as InboxShow);

/** Чи відповідає елемент фільтру «Показати». */
export function matchesShow(entry: IInboxEntry, show: InboxShow): boolean {
  if (show === 'all') return true;
  if (show === 'unread') return !entry.read;
  return entry.kind === show;
}

/** Лічильники «Показати» (за всіма просторами, як у прототипі). Чиста функція. */
export function showCounts(entries: readonly IInboxEntry[]): Record<InboxShow, number> {
  return Object.fromEntries(INBOX_SHOW.map((s) => [s, entries.filter((e) => matchesShow(e, s)).length])) as Record<InboxShow, number>;
}

/** Робочі простори, з яких є елементи, у порядку першої появи, з кількістю елементів. Чиста функція. */
export function workspaceCounts(entries: readonly IInboxEntry[]): Array<{ id: string; count: number }> {
  const out = new Map<string, number>();
  entries.forEach((e) => { if (e.workspaceId) out.set(e.workspaceId, (out.get(e.workspaceId) ?? 0) + 1); });
  return [...out].map(([id, count]) => ({ id, count }));
}
